const storageSizeMiddleware = store => next => action => {
    var total = 0;
    var amount = 0;
    console.log(action.type);
    for (var x in localStorage) {
        amount = (localStorage[x].length * 2) / 1024 / 1024;
        if (x == 'atlas'){
            console.log(x + " = " + amount.toFixed(2) + " MB");
        }
        if (!isNaN(amount)) {
            total += amount;
        }
    }
    console.log("Total: " + total.toFixed(2) + " MB");
    console.log(">>>>>>>>>>>>><<<<<<<<<<<<<<<");
    return next(action);
}
export default storageSizeMiddleware;